{
  "required": "This field is required",
  "email": {
    "invalid": "Enter a valid work email"
  },
  "password": {
    "required": "Password is required"
  },
  "phone": {
    "maxDigits": "Maximum {{count}} digits for {{country}}",
    "indianMobile": "Indian mobile numbers start with 6–9"
  }
}
